import React, { useCallback } from "react";
import DatePicker from "react-datepicker";
import { getYear, getMonth } from "date-fns";
import { range } from "lodash";

const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const DatePickerModal = (props) => {
    const {
        className,
        wrapperClassName,
        dateFormat,
        name,
        placeholderText,
        selected,
        onChange,
        onBlur,
        disabled,
        minDate,
        maxDate,
        autoComplete,
        showMonthYearPicker,
        minimumYear,
        maximumYear
    } = props;

    const years = range(minimumYear, maximumYear, 1);

    const CustomHeader = React.memo(({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }) => {
        return (
            <div
                style={{
                    margin: 10,
                    display: "flex",
                    justifyContent: "center",
                    gap: 8,
                }}
            >
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        decreaseMonth();
                    }}
                    disabled={prevMonthButtonDisabled}
                >
                    {"<"}
                </button>

                <select
                    value={MONTHS[getMonth(date)]}
                    onChange={(e) =>
                        changeMonth(MONTHS.indexOf(e.target.value))
                    }
                >
                    {MONTHS.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>

                <select
                    value={getYear(date)}
                    onChange={(e) => changeYear(Number(e.target.value))}
                >
                    {years.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>

                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        increaseMonth();
                    }}
                    disabled={nextMonthButtonDisabled}
                >
                    {">"}
                </button>
            </div>
        );
    });

    return (
        <DatePicker
            className={className}
            wrapperClassName={wrapperClassName}
            dateFormat={dateFormat}
            name={name}
            placeholderText={placeholderText}
            renderCustomHeader={(props) => <CustomHeader {...props} />}
            minDate={minDate}
            maxDate={maxDate}
            selected={selected}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            autoComplete={autoComplete}
            showMonthYearPicker={showMonthYearPicker}

        />
    );
};

export default DatePickerModal;